export const isWorkspaceSettingsEmpty = (
  subWorkspacesEnabled: boolean,
  workspaceSettings?: string[] | null,
) => {
  if (subWorkspacesEnabled) {
    if (!workspaceSettings?.length) {
      return true;
    }
  }

  return false;
};

/**
 * Extracts the subworkspace ids from an array of subworkspace strings.
 * @param subWorkspaces - array of subworkspace ids, can be in format of `<id>` or `own/<id>`.
 * @returns array of extracted subworkspace ids.
 */
export const extractSubworkspaceIds = (subWorkspaces?: string[] | null | undefined): string[] => {
  if (!subWorkspaces) {
    return [];
  }

  return subWorkspaces.map((idLike) => idLike.split('/').at(-1)).filter((id) => !!id) as string[];
};
